import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { IconButtonStyled } from "./styled";

const IconButton = ({
  theme_standard,
  icon,
  label,
  type = "button",
  onClick,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <IconButtonStyled className={customClass} type={type} onClick={onClick}>
      <div className="icon">{icon}</div>
      <div className="label">{label}</div>
    </IconButtonStyled>
  );
};

export default IconButton;
